'use strict';

import Vue from 'vue/dist/vue.common.js';
import $ from 'jquery';

// vuex
import store from '../vuex/store';

let Nav = Vue.extend({
  store,

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    loggedIn() { return this.$store.state.loggedIn; },
    csrfToken() { return this.$store.state.csrfToken; },
    watchVideo() { return this.$store.state.watchVideo; }
  },

  mounted() {
    const self = this;
  },

  methods: {
    toggleNav() {
      if (this.isOpen === false) {
        this.isOpen = true;
      } else { this.isOpen = false };
      $(this.$refs.nav).toggleClass('-active');
      $(this.$refs.toggle).toggleClass('-active');
    }
  }
})

export default Nav;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/nav.js